import { useState } from 'react';

import { cloneDeep } from '@revenuemarket/utils';

import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect';

export function useDeepCopiedState<T>(state: T) {
  const [innerState, setInnerState] = useState(() => cloneDeep(state));

  useIsomorphicLayoutEffect(() => {
    setInnerState(cloneDeep(state));
  }, [state]);

  return innerState;
}
